import Queue from '@sravni/utils/lib/queue';

var queue = new Queue({ debug: false });

export { queue as default };
//# sourceMappingURL=queue.js.map
